import { Ref, forwardRef, useRef, useState } from 'react'

import { useRouter } from 'next/router'

import clsx from 'clsx'

import { Link } from '@/components/CustomLink'

type Props = {
	className?: string
	title: string
	links: {
		link?: { href: string; target?: string }
		label: string
	}[]
	fallbackLabel?: string
}

export const HeaderSubnav = forwardRef(function HeaderSubnav(
	{ className, title = 'By Use Case', links, fallbackLabel = 'Select option' }: Props,
	ref: Ref<HTMLDivElement>
) {
	const router = useRouter()
	const activeLink = links.find(({ link }) => link?.href === router.asPath.replace(/\/$/, '')) ??
		links[0] ?? { label: fallbackLabel }
	const [open, setOpen] = useState(false)
	const trigger = useRef<HTMLButtonElement | null>(null)
	const container = useRef<HTMLDivElement | null>(null)

	return (
		<div ref={ref} className={clsx(className, 'bg-bc-black relative')}>
			<div ref={container}>
				<div className="max-w-[1156px] mx-auto flex px-3 py-2 relative items-center">
					<div className="text-white text-eyebrow uppercase pr-10 border-r border-gray-700">
						{title}
					</div>
					<div className="text-white text-eyebrow font-bold pl-10">
						<button
							ref={trigger}
							className="relative px-3 py-2 flex items-center gap-5"
							onClick={() => setOpen((v) => !v)}
						>
							{activeLink?.label}
							<span
								className={clsx(
									'h-[5px] w-[10px] border-[5px] border-b-0 border-x-transparent border-t-gray-900 transition-transform',
									open && 'rotate-180'
								)}
							></span>
							<div className="absolute -bottom-2 w-full left-0 bg-bc-blue h-1.5" />
						</button>
					</div>
				</div>
			</div>

			{open && (
				<ul
					className="absolute top-full w-full left-0 bg-bc-black text-white text-eyebrow pb-8 pt-3 animate-subnav-enter z-10"
					style={{
						paddingLeft:
							(trigger.current?.getBoundingClientRect().left ?? 0) -
							(container.current?.getBoundingClientRect().left ?? 0)
					}}
				>
					{links.map(({ link, label }, index) => (
						<li key={index}>
							<Link href={link?.href ?? '#'} target={link?.target} className="p-3 block w-[200px]">
								{label}
							</Link>
						</li>
					))}
				</ul>
			)}
		</div>
	)
})
